import { IsBoolean, IsEnum, IsNumber, IsString } from 'class-validator';
import { EntityVm } from 'api/core/entity.vm';

export enum OrderItemStatus {
  CLOSED = 'CLOSED',
  OPEN = 'OPEN',
}

export class OrderItemVm extends EntityVm {
  @IsString()
  supplierId: string;

  @IsString()
  supplierName: string;

  @IsString()
  orderId: string;

  @IsString()
  productId: string;

  @IsString()
  productSku: string;

  @IsString()
  productName: string;

  @IsString()
  externalId: string;

  @IsString()
  warehouseId: string;

  @IsBoolean()
  hasPendingQuantity: boolean;

  @IsNumber()
  quantity: number;

  @IsNumber()
  satisfiedQuantity: number;

  @IsEnum(OrderItemStatus)
  status: OrderItemStatus;

  @IsString()
  observations: string;
}
